import { CapoPlugin } from "/home/user/aiboosted-website/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];